import { Fragment, useEffect, useState } from 'react';

import classnames from 'classnames';

/* Material UI */
import TextField from '@material-ui/core/TextField';

/* Components */
import { NibCardItem } from '../NibCard';
/* Styles */
import css from './nibInput.module.sass';

const Input = (props) => <TextField {...props} />;

const NibInput = ({
  tools = ['info'],
  hideOnInit = false,
  label = '',
  onAdd = () => {},
  onClick = false,
  error = false,
  disabled = false,
  size = 'small',
  helperText,
  style = {},
  required = false,
  variant = 'outlined',
  value,
  onChange = () => {},
  onBlur = () => {},
  placeholder,
  className,
  inputStyles = {},
  name,
  paperLike = false,
  noCard = false,
  startAdornment = '',
  endAdornment = '',
  newUI = false,
  ...props
}) => {
  let [localType, setLocalType] = useState(tools.includes('hide') ? 'password' : 'text');
  let [localVal, setVal] = useState(value);
  let [showInfo, setShowInfo] = useState(false);

  useEffect(() => {
    if (tools.includes('hide') && !hideOnInit) {
      setLocalType('text');
    }
  }, []);

  useEffect(() => {
    if (localVal !== value) {
      setVal(value);
    }
  }, [value]);

  let fieldProps = {
    name,
    error,
    placeholder,
    size,
    disabled,
    variant,
    onBlur,
    value,
    className: classnames(className ? className : '', paperLike ? css.paperLike : ''),
    style: { ...style },
    type: localType,
    color: 'primary',
    onChange: (e) => onChange(e),
    helperText: showInfo && helperText,
    InputProps: {
      startAdornment: startAdornment,
      endAdornment: endAdornment,
    },
    inputProps: {
      style: { ...inputStyles },
      autoComplete: 'off',
      role: 'text',
      'aria-autocomplete': 'none',
    },
    ...props,
  };

  const labelText = (
    <Fragment>
      {label} {required && <i>*</i>}
    </Fragment>
  );

  return noCard ? (
    <Input {...fieldProps} />
  ) : (
    <NibCardItem
      name={labelText}
      btns={!helperText && [...tools].includes('info') ? [...tools].filter((tool) => tool !== 'info') : [...tools]}
      onAdd={() => onAdd()}
      onHide={() => setLocalType(localType === 'text' ? 'password' : 'text')}
      onInfo={() => setShowInfo(!showInfo)}
      isHideActive={hideOnInit}
      newUI={newUI}
    >
      {onClick ? (
        <div className={css.container}>
          <div onClick={onClick} className={css.overlay} style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}></div>
          <div className={`${css.inner} ${[...tools].includes('add') ? css.add : ''}`}>
            <Input {...fieldProps} />
          </div>
        </div>
      ) : (
        <Input {...fieldProps} />
      )}
      {error && <p className={'customErrorMsg'}>{error}</p>}
    </NibCardItem>
  );
};

export default NibInput;
